/** Route prefix every optional onboarding step lives under. */
export const ONBOARDING_PREFIX = '/onboarding/'
